// src/sentry-config.ts
var FRONTEND_IGNORED_ERRORS = [
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications",
  "Non-Error promise rejection captured",
  "NavigationDuplicated"
];
var PAYMENT_SDK_IGNORED_ERRORS = [
  "Failed to load Stripe.js",
  "PayPal Smart Buttons could not be rendered"
];
var BACKEND_NETWORK_IGNORED_ERRORS = [
  "ECONNRESET",
  "ETIMEDOUT",
  "ENOTFOUND"
];
function stripSensitiveHeaders(event) {
  if (event.request) {
    const req = event.request;
    delete req.cookies;
    if (req.headers) {
      const headers = req.headers;
      delete headers.authorization;
      delete headers.cookie;
      delete headers["x-api-key"];
      delete headers["x-goog-api-key"];
      delete headers["X-Goog-Api-Key"];
      delete headers.Authorization;
      delete headers.Cookie;
      delete headers["X-API-Key"];
    }
  }
  return event;
}
var ROUTES_ADRESSES = "/api/adresses/";
var HOTES_ADRESSES = [
  "data.geopf.fr",
  "api-adresse.data.gouv.fr",
  "places.googleapis.com",
  "photon.komoot.io",
  "nominatim.openstreetmap.org"
];
function reduireUrlAdresse(url) {
  if (!HOTES_ADRESSES.some((h) => url.includes(h))) return url;
  const coupe = url.search(/[?#]/);
  return coupe === -1 ? url : url.slice(0, coupe);
}
function reduireUrlsDansTexte(texte) {
  if (!HOTES_ADRESSES.some((h) => texte.includes(h))) return texte;
  return texte.replace(/https?:\/\/[^\s"']+/g, (u) => reduireUrlAdresse(u));
}
function nettoyerObjetUrls(objet) {
  if (!objet || typeof objet !== "object") return;
  const o = objet;
  const visAdresse = Object.values(o).some((v) => typeof v === "string" && HOTES_ADRESSES.some((h) => v.includes(h)));
  if (!visAdresse) return;
  for (const cle of Object.keys(o)) {
    const v = o[cle];
    if (typeof v === "string") o[cle] = reduireUrlsDansTexte(v);
  }
  delete o["http.query"];
  delete o["url.query"];
  delete o["http.fragment"];
}
function masquerAdressesSaisies(event) {
  const req = event.request;
  if (req?.url && req.url.includes(ROUTES_ADRESSES)) {
    delete req.query_string;
    delete req.data;
    req.url = req.url.split("?")[0];
  }
  if (req?.url) req.url = reduireUrlAdresse(req.url);
  if (Array.isArray(event.spans)) {
    for (const span of event.spans) {
      if (typeof span.description === "string") span.description = reduireUrlsDansTexte(span.description);
      nettoyerObjetUrls(span.data);
    }
  }
  const fil = event.breadcrumbs;
  const miettes = Array.isArray(fil) ? fil : Array.isArray(fil?.values) ? fil.values : [];
  for (const miette of miettes) {
    if (typeof miette.message === "string") miette.message = reduireUrlsDansTexte(miette.message);
    nettoyerObjetUrls(miette.data);
  }
  return event;
}
function masquerAdresseMiette(miette) {
  if (typeof miette.message === "string") miette.message = reduireUrlsDansTexte(miette.message);
  nettoyerObjetUrls(miette.data);
  return miette;
}
function masquerAdressesReplay(evenement) {
  const charge = evenement?.data?.payload;
  if (charge && typeof charge === "object") {
    const p = charge;
    for (const cle of ["description", "message"]) {
      if (typeof p[cle] === "string") p[cle] = reduireUrlsDansTexte(p[cle]);
    }
    nettoyerObjetUrls(p.data);
  }
  return evenement;
}
function shouldEnableSentry(options) {
  if (typeof options.enabled === "boolean") return options.enabled;
  const env = options.environment ?? "development";
  return env === "production";
}
function getFrontendClientConfig(options) {
  const enabled = shouldEnableSentry(options);
  return {
    dsn: options.dsn ?? void 0,
    enabled,
    environment: options.environment ?? "development",
    tracesSampleRate: options.tracesSampleRate ?? 0.1,
    replaysSessionSampleRate: options.replaysSessionSampleRate ?? 0.1,
    replaysOnErrorSampleRate: options.replaysOnErrorSampleRate ?? 1,
    ignoreErrors: [
      ...FRONTEND_IGNORED_ERRORS,
      ...PAYMENT_SDK_IGNORED_ERRORS,
      ...options.extraIgnoreErrors ?? []
    ],
    beforeSend(event) {
      return masquerAdressesSaisies(stripSensitiveHeaders(event));
    },
    // Transactions (browserTracing) : spans « http.client » vers la
    // Géoplateforme, URL avec `?q=<adresse>`.
    beforeSendTransaction(event) {
      return masquerAdressesSaisies(stripSensitiveHeaders(event));
    },
    beforeBreadcrumb(miette) {
      return masquerAdresseMiette(miette);
    }
  };
}
function getFrontendServerConfig(options) {
  const enabled = shouldEnableSentry(options);
  return {
    dsn: options.dsn ?? void 0,
    enabled,
    environment: options.environment ?? "development",
    tracesSampleRate: options.tracesSampleRate ?? 0.1,
    ignoreErrors: [
      "Non-Error promise rejection captured",
      ...options.extraIgnoreErrors ?? []
    ],
    beforeSend(event) {
      return masquerAdressesSaisies(stripSensitiveHeaders(event));
    },
    beforeSendTransaction(event) {
      return masquerAdressesSaisies(stripSensitiveHeaders(event));
    },
    beforeBreadcrumb(miette) {
      return masquerAdresseMiette(miette);
    }
  };
}
function getBackendConfig(options) {
  const enabled = shouldEnableSentry(options);
  return {
    dsn: options.dsn ?? void 0,
    enabled,
    environment: options.environment ?? "development",
    tracesSampleRate: options.tracesSampleRate ?? 0.1,
    profilesSampleRate: options.profilesSampleRate ?? 0.1,
    ignoreErrors: [
      ...BACKEND_NETWORK_IGNORED_ERRORS,
      ...options.extraIgnoreErrors ?? []
    ],
    beforeSend(event) {
      return masquerAdressesSaisies(stripSensitiveHeaders(event));
    },
    // Les transactions portent aussi les URL sortantes (spans) et la requête
    // entrante : mêmes nettoyages que les erreurs.
    beforeSendTransaction(event) {
      return masquerAdressesSaisies(stripSensitiveHeaders(event));
    }
  };
}

// src/analytics.ts
var noopAnalyticsAdapter = {
  identify() {
  },
  reset() {
  },
  track() {
  }
};
function wrapSafe(adapter, options) {
  const log = options?.logger ?? (() => {
  });
  const debug = options?.debug ?? false;
  return {
    identify(userId, traits) {
      try {
        adapter.identify(userId, traits);
      } catch (err) {
        if (debug) log(`analytics.identify failed: ${err}`);
      }
    },
    reset() {
      try {
        adapter.reset();
      } catch (err) {
        if (debug) log(`analytics.reset failed: ${err}`);
      }
    },
    track(name, props) {
      try {
        adapter.track(name, props);
      } catch (err) {
        if (debug) log(`analytics.track(${name}) failed: ${err}`);
      }
    }
  };
}
function wrapBrowserOnly(adapter) {
  return {
    identify(userId, traits) {
      if (typeof window === "undefined") return;
      adapter.identify(userId, traits);
    },
    reset() {
      if (typeof window === "undefined") return;
      adapter.reset();
    },
    track(name, props) {
      if (typeof window === "undefined") return;
      adapter.track(name, props);
    }
  };
}
function createAnalytics(baseAdapter, options) {
  return wrapBrowserOnly(wrapSafe(baseAdapter, options));
}
function multiAdapter(...adapters) {
  return {
    identify(userId, traits) {
      for (const a of adapters) a.identify(userId, traits);
    },
    reset() {
      for (const a of adapters) a.reset();
    },
    track(name, props) {
      for (const a of adapters) a.track(name, props);
    }
  };
}

export { BACKEND_NETWORK_IGNORED_ERRORS, FRONTEND_IGNORED_ERRORS, PAYMENT_SDK_IGNORED_ERRORS, createAnalytics, getBackendConfig, getFrontendClientConfig, getFrontendServerConfig, masquerAdresseMiette, masquerAdressesReplay, masquerAdressesSaisies, multiAdapter, noopAnalyticsAdapter, reduireUrlAdresse, shouldEnableSentry, stripSensitiveHeaders, wrapBrowserOnly, wrapSafe };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map